import { PartTypeType } from "../types";
import { isRoundPartType } from "./isRoundPartType";
import { isSquarePartType } from "./isSquarePartType";

export const isRoundOrSquare = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  return isRoundPartType(partType) || isSquarePartType(partType);
};
